import React, { Box, Collapse, IconButton, TableCell, TableRow } from '@mui/material';
import { useState } from 'react';
import { Collapser, PartnerForm } from 'components';

export const PartnerEmptyRow = () => {
	const [open, setOpen] = useState(false);
	return (
		<>

			<TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
				<TableCell>
					<IconButton aria-label='expand row' size='small' onClick={() => setOpen(!open)}>
						<Collapser isAdd={true} open={open} />
					</IconButton>
				</TableCell>
				<TableCell component='th' scope='row'></TableCell>
				<TableCell align='right'></TableCell>
				<TableCell align='right'></TableCell>
				<TableCell align='right'></TableCell>
				<TableCell align='right'></TableCell>
				<TableCell align='right'></TableCell>
				<TableCell align='right'></TableCell>
				<TableCell align='right'></TableCell>
			</TableRow>
			<TableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
					<Collapse in={open} timeout='auto'>
						<Box sx={{ margin: 2 }}>
							<PartnerForm />
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
}
